import Component from '../abstracts/Component';
import TrackingComponent from './TrackingComponent';

export default class SizeSelectorComponent extends Component {

  get COMPONENTNAME() {
    return 'SizeSelectorComponent';
  }

  get SELECTORS() {
    return {
      size: '[data-size] input',
      sizeRadioBox: '[data-size]',
      wishlistSize: '[data-sizes-select] select',
      lowStockMsg: '[data-js-low-stock]',
      noSizeMsg: '[data-js-no-size]',
    };
  }

  get CLASSES() {
    return {
      selected: 'selected',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.TrackingComponent = new TrackingComponent();
  }

  readDOM() {
    return {
      box: this.$component,
      sizes: this.$component.querySelectorAll(this.SELECTORS.size),
      wishlistSize: this.$component.querySelector(this.SELECTORS.wishlistSize),
      lowStockMsg: this.$component.querySelector(this.SELECTORS.lowStockMsg),
      noSizeMsg: this.$component.querySelector(this.SELECTORS.noSizeMsg)
    };
  }

  // put classes on selected size
  selectSize(size) {
    let prevSize = this.dom.box.querySelector('.selected');
    if (prevSize) {
      prevSize.classList.remove(this.CLASSES.selected);
      prevSize.querySelector('input').setAttribute('aria-checked', 'false');
    }
    size.closest(this.SELECTORS.sizeRadioBox).classList.add(this.CLASSES.selected);
    size.setAttribute('aria-checked', 'true');

    // for screen reader: announce when the size has been selected
    this.announce(size);

  }

  announce(size) {
    const liveRegion = document.getElementById('aria-live-announcements');
    if (!liveRegion) return;

    const unavailableLabel = liveRegion.dataset.labelUnavailable;
    const selectedLabel = liveRegion.dataset.labelSelected;

    const labelText = size.closest('label')?.innerText.trim() || '';

    const message = size.dataset.unavailable === 'true'
      ? unavailableLabel
      : `${selectedLabel} ${labelText}`;

    liveRegion.textContent = message;
  }


  bindEvents() {
    let ctx = this;
    // pdp CTA
    if (this.dom.sizes.length) {
      let allSizesUnavailable = true;
      this.dom.sizes.forEach(size => {
        const label = size.closest('label');

        // for screean reader
        if (size.dataset.unavailable === 'true') {
          size.setAttribute('aria-disabled', 'true');
          label.setAttribute('aria-disabled', 'true');
          label.classList.add('unavailable');
        } else {
          size.removeAttribute('aria-disabled');
          label.removeAttribute('aria-disabled');
          label.classList.remove('unavailable');
        }

        size.addEventListener('click', () => {
          // put size
          this.selectSize(size);
          // if not available launch notify me event
          if (size.dataset.unavailable === 'true') {
            // TODO: remove size from payloads?
            this.$emit(this.$customEvents.PRODUCT_EVENTS.notifyme, { size: size.getAttribute('data-product-code'), box: this.dom.box });
            this.$emit(this.$customEvents.CHANGE_RETURN_STEPS.disabledConfirm, { size: size });
          } else {
            // if available i want to hide the notifyme form
            this.$emit(this.$customEvents.PRODUCT_EVENTS.notifymeclose, { size: size.getAttribute('data-product-code'), box: this.dom.box });
            this.$emit(this.$customEvents.CHANGE_RETURN_STEPS.enableConfirm, { size: size });
          }
          if (size.dataset.lowStock === "true") {
            this.dom.lowStockMsg.classList.remove("hidden");
          } else {
            this.dom.lowStockMsg.classList.add("hidden");
          }
          // general event
          this.$emit(this.$customEvents.PRODUCT_EVENTS.sizechanged, {
            productCode: size.dataset.productCode,
            isWishlist: size.dataset.isWishlist
          });
          this.dom.noSizeMsg.classList.add("hidden");
          // reset error
          // find error box
          let sizeErrorBox = document.querySelector('[data-sizes-error=prod_' + this.$component.dataset.productCode + ']');
          if (sizeErrorBox && !sizeErrorBox.classList.contains('hidden')) {
            sizeErrorBox.classList.add('hidden');
            sizeErrorBox.innerHTML = '';
          }
        });

        //for keyboard navigation
        label.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            size.click();
          }
        });

        if (size.dataset.unavailable !== 'true') {
          allSizesUnavailable = false;
        }
      });

      window.addEventListener('load', () => {
        if (allSizesUnavailable) {
          // if every size is unavailable, fire event on load
          console.log("notifyme event");
          this.$emit(this.$customEvents.PRODUCT_EVENTS.notifyme, { unavailable: true, box: this.dom.box });
        }
      });
    }

    this.$on(this.$customEvents.SIZES_EVENTS.sizesupdate, ({ payload }) => {
      this.dom.sizes.forEach(size => {
        if (size.dataset.productCode === payload.code) {
          size.dataset.isWishlist = payload.isWishlist;
        }
      });
    });

    this.$on(this.$customEvents.SIZES_EVENTS.noSizeSelected, () => {
      this.dom.noSizeMsg.classList.remove("hidden");
    });
  }

  render() {
    this.log('Rendering...');
    this.dom = this.readDOM();
    this.bindEvents();
  }
}
